export default __webpack_public_path__ + "static/opdemo2-online-lockup-6730d597a96edd42a36e57f419e445a4.png";